export default __webpack_public_path__ + "static/media/signup.d23afea6.png";